module.exports = __webpack_public_path__ + "img/dianxin.3b898587.png";